export default {
  title: 'Vat',

  labels: {
    enableTax: 'Enable vat',
    purchaseTax: 'Purchase vat percent',
    saleTax: 'Sale vat percent',
    serviceTax: 'Service vat percent',
    taxRegistrationNumber: 'Tax Registration Number',
    enableShippingTax: 'Shipping price includes vat'
  },

  notifications: {
    edit: {
      success: 'Vat information has been updated successfully',
      error: 'Update vat information has error'
    }
  }
}
